import React from "react";
import { Text, IconContainer, Flex } from "shipnow-mercurio";
import { Styles } from "./NotFoundOptions.styles";
export const NotFoundOptions = () => {
  return (
    <Styles.CenteredPanel color="blackSurface">
      <Flex style={{ height: "300px" }}>
        <IconContainer icon="error" color="error" />
        <Text color="error" margin="l-8" size="bodySemibold">
          No hay sucursales disponibles
        </Text>
      </Flex>
    </Styles.CenteredPanel>
  );
};
